import { ConfigurationGroupType, ConfigurationGroupOptionType } from 'shared-types/SpaPackage';
import { SelectedExperienceType } from '../types';

export const getSelectableOptions = (
  configGroups: ConfigurationGroupType[],
  experiences: { optionGroupId?: number | string; options: SelectedExperienceType[] }
): ConfigurationGroupOptionType[] => {
  const selectedExperienceOptionIds = experiences.options.map((opt) => Number(opt.optionId));
  const scopedGroups =
    experiences.optionGroupId !== undefined
      ? configGroups.filter((conf) => Number(conf.id) === Number(experiences.optionGroupId))
      : configGroups;
  const scopedOptions = scopedGroups.flatMap((conf) => conf.options);

  return scopedOptions.filter((option) => selectedExperienceOptionIds.includes(option.id));
};
